const keyDownSet = new Set<number>();

/**
 * Erlaubt globalen Zugriff auf die Info, ob eine Taste zur Zeit gedrückt ist.
 */
export class KeyState {
  static isAlt(): boolean {
    return keyDownSet.has(18);
  }

  static isCtrl(): boolean {
    return keyDownSet.has(17);
  }

  static isCommand(): boolean {
    return keyDownSet.has(91) || keyDownSet.has(93);
  }

  static isShift(): boolean {
    return keyDownSet.has(16);
  }

  static isAltGr(): boolean {
    return keyDownSet.has(255);
  }

  static getKeySet(): Set<number> {
    return keyDownSet;
  }
}

document.onkeydown = function (e: KeyboardEvent): void {
  keyDownSet.add(getKey(e));
};

document.onkeyup = function (e: KeyboardEvent): void {
  keyDownSet.delete(getKey(e));
};

function getKey(e: KeyboardEvent): number {
  // @ts-ignore 'which' is deprecated but required for legacy support/logic preservation
  return typeof e.which == "number" ? e.which : e.keyCode;
}
